var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3690",
    "data-name": "Groupe 3690",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.419,
    height: 24,
    viewBox: "0 0 18.419 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1588",
    "data-name": "Rectangle 1588",
    width: 18.419,
    height: 24,
    fill: "#6639b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3689",
    "data-name": "Groupe 3689",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13490",
    "data-name": "Trac\\xE9 13490",
    d: "M15.911,66.149H2.512A2.511,2.511,0,0,1,.437,62.224,10.521,10.521,0,0,1,9.211,58a10.522,10.522,0,0,1,8.775,4.225,2.522,2.522,0,0,1-2.075,3.925",
    transform: "translate(0 -42.149)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13491",
    "data-name": "Trac\\xE9 13491",
    d: "M17.453,1.869H13.089V.935L13.082.808A.935.935,0,0,0,12.155,0l-.127.008a.935.935,0,0,0-.808.926v.934H6.857a2.8,2.8,0,0,0-2.8,2.8v5.615a2.8,2.8,0,0,0,2.8,2.8h10.6a2.8,2.8,0,0,0,2.8-2.8V4.674a2.8,2.8,0,0,0-2.8-2.8m-9.66,5.3A1.557,1.557,0,1,1,9.35,8.723,1.557,1.557,0,0,1,7.792,7.166m5.985,4.423H10.768a.683.683,0,0,1,0-1.366h3.009a.683.683,0,1,1,0,1.366M14.95,8.723a1.557,1.557,0,1,1,1.557-1.557A1.557,1.557,0,0,1,14.95,8.723",
    transform: "translate(-2.945 0)",
    fill: "#6639b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobot);
export default __webpack_public_path__ + "static/media/icon_robot.45bbee82bdf7916c4c80b4412d231d8a.svg";
export { ForwardRef as ReactComponent };